<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo},
    data() {
        return {
            code: '',
            loading: false,
            error: null
        }
    },
    methods: {
        login() {
            this.loading = true;
            this.$auth.otcLogin({code: this.code}).then((data) => {
                this.loading = false;
                if (data && data.error) {
                    this.error = data.error;
                }
            });
        }
    }
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <a href="/"><Logo/></a>
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">
                        <form @submit.prevent="login" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.one_time_code_login.title_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <b-field :label="$t('auth.fields.one_time_login_code.name')"
                                         label-for="code"
                                         :type="error ? 'is-danger' : null"
                                         :message="error">
                                    <b-input required
                                             type="text"
                                             id="code"
                                             name="code"
                                             placeholder="01234567"
                                             v-model="code"
                                             icon="key"
                                    ></b-input>
                                </b-field>
                                <div class="buttons is-centered mt-4 is-flex">
                                    <b-button @click="$router.push({name: 'login'})">
                                        {{ $t('actions.back') }}
                                    </b-button>
                                    <button class="button is-success is-flex-grow-5"
                                            type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        {{ $t('auth.actions.login') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style>
</style>
